module.exports = __webpack_public_path__ + "img/maatafa_no.7785b85f.png";